export default "__VITE_ASSET__32814910__"